import { api } from './client';

export type InterestRateScope = 'HTX' | 'FARMER';

export interface BackendInterestRateOverride {
  _id: string;
  scope: InterestRateScope;
  targetId: string;
  ratePercentPerYear: number;
  active: boolean;
  notes?: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

/** HTX_STAFF may only pass its own htxId when scope='HTX' (server-enforced —
 * a mismatched htxId or a missing scope/targetId is refused with 403). */
export async function listInterestRateOverrides(params: { scope: InterestRateScope; targetId: string; active?: boolean }): Promise<BackendInterestRateOverride[]> {
  const query = new URLSearchParams({ scope: params.scope, targetId: params.targetId });
  if (params.active !== undefined) query.set('active', String(params.active));
  return api.get<BackendInterestRateOverride[]>(`/interest-rate-overrides?${query.toString()}`);
}

export async function createInterestRateOverride(payload: { scope: InterestRateScope; targetId: string; ratePercentPerYear: number; notes?: string }): Promise<BackendInterestRateOverride> {
  return api.post<BackendInterestRateOverride>('/interest-rate-overrides', payload);
}

export async function updateInterestRateOverride(id: string, payload: { ratePercentPerYear?: number; notes?: string; active?: boolean }): Promise<BackendInterestRateOverride> {
  return api.patch<BackendInterestRateOverride>(`/interest-rate-overrides/${id}`, payload);
}
